import { cn } from "@/lib/cn";
import { Card } from "../Card";
import { Skeleton } from "../Skeleton";
import { RegionCargando } from "./RegionCargando";

export interface KpiGridSkeletonProps {
  n?: number;
  className?: string;
}

/** Tarjetas de KPI (etiqueta, valor, detalle) · 2 columnas en móvil, `n` en escritorio (máx. 4). */
export function KpiGridSkeleton({ n = 4, className }: KpiGridSkeletonProps) {
  return (
    <RegionCargando
      etiqueta="Cargando indicadores…"
      className={cn("grid grid-cols-2 gap-4", n >= 4 ? "md:grid-cols-4" : n === 3 ? "md:grid-cols-3" : "md:grid-cols-2", className)}
    >
      {Array.from({ length: n }, (_, i) => (
        <Card key={i} padding="md" aria-hidden="true">
          <Skeleton height={10} width="55%" />
          <Skeleton height={26} width="45%" className="mt-2.5" />
          <Skeleton height={10} width="30%" className="mt-2" />
        </Card>
      ))}
    </RegionCargando>
  );
}
